<template>
  <div id="app">
    <Tabs />
  </div>
</template>

<script>
import Tabs from "@/components/Tabs.vue";
export default {
  name: "App",
  components: {
    Tabs,
  },
};
</script>

<style lang="scss">
@import "@/assets/imports/media.scss";
#app {
  -webkit-font-smoothing: antialiased;
  touch-action: manipulation;
  -moz-osx-font-smoothing: grayscale;
  font-family: "Montserrat", sans-serif;
}
#app * {
  box-sizing: border-box;
}
</style>
